export const SECTION_TYPE = {
  REGISTRATION_STATUS: "REGISTRATION_STATUS",
  ASR_STATUS: "ASR_STATUS",
}

export default {
  SECTION_TYPE
};